/* eslint-disable */
import React, { useContext, useState } from "react";

import { useHistory, Link as Linker } from "react-router-dom";
import {
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import {
  Grid,
  Paper,
  Button,
  Typography,
} from "@material-ui/core";
import {
  backgroundStyle,
  btnStyle,
  forgotPasswordStyle,
  inputStyle,
  labelStyle,
  paperStyle,
  TypographyStyle,
} from "./styles";
import { useValidCode } from "../../hooks/useValidCode";
import { AuthContext } from "../../contexts/authContext";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { useValidEmail } from "hooks/useValidEmail";
import { Header } from "components/Header/Header";

const VerifyAccount: React.FC<any> = () => {
  /* States and context declaration */
  const { code, setCode, codeIsValid } = useValidCode("");
  const [, setError] = useState("");
  const authContext = useContext(AuthContext);
  const { email, setEmail } = useValidEmail(null);
  const [showPassword, setshowPassword] = useState<boolean>(false);

  // const navigation = useNavigate();
  const history = useHistory();

  /* Generic Error Message */
  const [, setGenericErrorMessage] = useState("");

  // /* Callback and Memo, Optimization Section */

  /* 
  Functions Section 
  */

  const handleClickShowPassword = () => {
    setshowPassword(!showPassword);
  };



  const sendCode = async (e: any) => {
    e.stopPropagation();

    if (code) {
      if (code.length === 0 || code.length > 6) {
        setError("In valid code");
        return;
      }
      try {
        setCode("");
        // navigation("/RegisterComplete");
        history.push("/RegisterComplete");
      } catch (error: any) {
        setGenericErrorMessage(error.message);
      }
    }
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <>
      <Header showSettings={false}/>
      <div style={backgroundStyle}>
        <Grid>
          <Paper elevation={0} style={paperStyle}>
            <div style={{ margin: "0px auto", width: "315px" }}>
              {/* {genericErrorMessage === "" && codeIsValid === "" ? null : (
              <Alert style={alertStyle} variant="outlined" severity="error">
                Error:{" "}
                {genericErrorMessage === ""
                  ? "The 6-digit code entered is incorrect."
                  : genericErrorMessage}
                .
              </Alert>
            )} */}
              <FormControl sx={{ width: "25ch" }} variant="outlined">
                <OutlinedInput
                  id="outlined-adornment-email"
                  style={{ ...inputStyle, marginTop: "0" }}
                  type="text"
                  value={email}
                  onChange={(e: any) => setEmail(e.target.value)}
                  placeholder="Email"
                />
              </FormControl>
              <FormControl sx={{ width: "25ch" }} variant="outlined">
                <OutlinedInput
                  id="outlined-adornment-password"
                  style={inputStyle}
                  type={showPassword ? "text" : "password"}
                  value={code}
                  onChange={(e: any) => setCode(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  placeholder="Temporary Password"
                />
              </FormControl>
              <div style={labelStyle}>
                <Typography>
                  <Linker to="/ForgotPasswordEmail" style={forgotPasswordStyle}>
                    Resend Invite Code
                  </Linker>
                </Typography>
              </div>
            </div>
          </Paper>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            style={btnStyle}
            fullWidth
            onClick={(e) => {
              sendCode(e);
            }}
            disabled={codeIsValid === "" ? false : true}
          >
            Submit
          </Button>
          <Typography style={TypographyStyle}>
            Have an account?{" "}
            <Linker to="/SignIn" style={forgotPasswordStyle}>
              Login Here
            </Linker>
          </Typography>
          {/* <Typography style={TypographyStyle}>
          {" "}
          Have an account? <Linker to="/SignIn"> Login Here</Linker>
        </Typography> */}
        </Grid>
      </div>
    </>
  );
};

export default VerifyAccount;
